// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/opt/build/repo/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 't__plugin-layout__Layout' */'/opt/build/repo/src/.umi-production/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/user",
        "layout": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'/opt/build/repo/src/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "login",
            "path": "/user/login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login' */'/opt/build/repo/src/pages/user/login'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/",
        "layout": false,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'/opt/build/repo/src/layouts/SecurityLayout'), loading: LoadingComponent}),
        "authority": [
          "admin"
        ],
        "routes": [
          {
            "path": "/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'/opt/build/repo/src/layouts/BasicLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/setup",
                "name": "setup",
                "routes": [
                  {
                    "name": "roles",
                    "path": "/setup/roles",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__setup__role__tables' */'/opt/build/repo/src/pages/setup/role/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create-Roles",
                    "path": "/setup/create-roles",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__setup__role__tables__create' */'/opt/build/repo/src/pages/setup/role/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "edit Roles",
                    "path": "/setup/create-roles/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__setup__role__tables__create' */'/opt/build/repo/src/pages/setup/role/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "users",
                    "path": "/setup/users",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__setup__users__tables' */'/opt/build/repo/src/pages/setup/users/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create-users",
                    "path": "/setup/create-users",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__setup__users__tables__create' */'/opt/build/repo/src/pages/setup/users/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/player",
                "name": "pam",
                "icon": "global",
                "authority": [
                  "admin",
                  "pam-admin"
                ],
                "access": "isAccessible",
                "routes": [
                  {
                    "name": "players",
                    "icon": "team",
                    "path": "/player/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__list' */'/opt/build/repo/src/pages/player/list'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "transactions",
                    "icon": "table",
                    "path": "/player/transactions",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__transactions' */'/opt/build/repo/src/pages/player/transactions'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "kycs",
                    "icon": "table",
                    "path": "/player/kycs",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__kycs' */'/opt/build/repo/src/pages/player/kycs'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "withdrawals",
                    "icon": "table",
                    "path": "/player/withdrawals",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__withdrawals' */'/opt/build/repo/src/pages/player/withdrawals'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Withdrawal Fee",
                    "icon": "table",
                    "path": "/player/withdrawalFee",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__withdrawalsFee' */'/opt/build/repo/src/pages/player/withdrawalsFee'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "payments",
                    "icon": "table",
                    "path": "/player/paymentMethods",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__paymentMethods' */'/opt/build/repo/src/pages/player/paymentMethods'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "account",
                    "icon": "smile",
                    "path": "/player/accountcenter",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__AccountCenter' */'/opt/build/repo/src/pages/player/AccountCenter'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "userAnalytics",
                    "icon": "smile",
                    "path": "/player/accountcenter/userAnalytics",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__AccountCenter__components__UserAnalytics' */'/opt/build/repo/src/pages/player/AccountCenter/components/UserAnalytics'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "deposit-history",
                    "icon": "table",
                    "path": "/player/depositHistory",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__depositHistory' */'/opt/build/repo/src/pages/player/depositHistory'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "manual-deposit",
                    "icon": "smile",
                    "path": "/player/manual-accounts",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__manualDeposit__tables' */'/opt/build/repo/src/pages/player/manualDeposit/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create-manual-accounts",
                    "icon": "smile",
                    "path": "/player/create-manual-accounts",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__manualDeposit__tables__create' */'/opt/build/repo/src/pages/player/manualDeposit/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "path": "/player/psp",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__psp' */'/opt/build/repo/src/pages/player/psp'), loading: LoadingComponent}),
                    "name": "psp",
                    "icon": "global",
                    "exact": true
                  },
                  {
                    "name": "TDS",
                    "icon": "table",
                    "path": "/player/TDS",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__player__tdscomponent' */'/opt/build/repo/src/pages/player/tdscomponent'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/bots",
                "name": "bots",
                "icon": "global",
                "authority": [
                  "admin",
                  "pam-admin"
                ],
                "access": "isAccessible",
                "routes": [
                  {
                    "name": "players",
                    "icon": "team",
                    "path": "/bots/list",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bots__list' */'/opt/build/repo/src/pages/bots/list'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "account",
                    "icon": "smile",
                    "path": "/bots/accountcenter",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bots__AccountCenter' */'/opt/build/repo/src/pages/bots/AccountCenter'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/rgs",
                "authority": [
                  "rgs-admin",
                  "admin"
                ],
                "name": "rgs",
                "icon": "crown",
                "access": "isAccessible",
                "routes": [
                  {
                    "name": "tickets",
                    "icon": "smile",
                    "path": "/rgs/tickets",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rgs__tickets' */'/opt/build/repo/src/pages/rgs/tickets'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "wagers",
                    "icon": "dollar",
                    "path": "/rgs/buyins",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rgs__buyins' */'/opt/build/repo/src/pages/rgs/buyins'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/servicerequest",
                "name": "service-request",
                "icon": "SerReq",
                "authority": [
                  "admin",
                  "servicerequest-admin"
                ],
                "access": "isAccessible",
                "routes": [
                  {
                    "name": "automatedWithdraw",
                    "icon": "team",
                    "path": "/servicerequest/automatedWithdraw",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__automatedWithdraw' */'/opt/build/repo/src/pages/servicerequest/automatedWithdraw'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Cashback",
                    "icon": "team",
                    "path": "/servicerequest/cashback",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__cashback' */'/opt/build/repo/src/pages/servicerequest/cashback'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create-cashback",
                    "icon": "team",
                    "path": "/servicerequest/create-cashback",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__cashback__create' */'/opt/build/repo/src/pages/servicerequest/cashback/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Clawback",
                    "icon": "team",
                    "path": "/servicerequest/clawback",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__clawback' */'/opt/build/repo/src/pages/servicerequest/clawback'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Clawback Task",
                    "icon": "team",
                    "path": "/servicerequest/clawbacktask/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__clawbacktask' */'/opt/build/repo/src/pages/servicerequest/clawbacktask'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "create-clawback",
                    "icon": "team",
                    "path": "/servicerequest/create-clawback",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__clawback__create' */'/opt/build/repo/src/pages/servicerequest/clawback/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Player Update",
                    "icon": "team",
                    "path": "/servicerequest/playerUpdate",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__playerUpdate' */'/opt/build/repo/src/pages/servicerequest/playerUpdate'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": " GP Transactions",
                    "icon": "team",
                    "path": "/servicerequest/gpTransactions",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__gpi' */'/opt/build/repo/src/pages/servicerequest/gpi'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "llManagerImport",
                    "icon": "team",
                    "path": "/servicerequest/llManagerImport",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__llManagerImport' */'/opt/build/repo/src/pages/servicerequest/llManagerImport'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create-llManagerImport",
                    "icon": "team",
                    "path": "/servicerequest/create-llManagerImport",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__llManagerImport__create' */'/opt/build/repo/src/pages/servicerequest/llManagerImport/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Player Flags",
                    "icon": "team",
                    "path": "/servicerequest/playerFlag",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__playerFlag' */'/opt/build/repo/src/pages/servicerequest/playerFlag'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Player Flags Task",
                    "icon": "team",
                    "path": "/servicerequest/playerFlag/playerflagtask/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__playerFlag__playerflagtask' */'/opt/build/repo/src/pages/servicerequest/playerFlag/playerflagtask'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "create-PlayerFlags",
                    "icon": "team",
                    "path": "/servicerequest/create-playerFlags",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__playerFlag__create' */'/opt/build/repo/src/pages/servicerequest/playerFlag/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "withdrawalRules",
                    "icon": "team",
                    "path": "/servicerequest/withdrawalRules",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__withdrawalRules' */'/opt/build/repo/src/pages/servicerequest/withdrawalRules'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Play Bonus CSV",
                    "icon": "team",
                    "path": "/servicerequest/playBonusCSV",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__playBonusCSV' */'/opt/build/repo/src/pages/servicerequest/playBonusCSV'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "PlayBonusCSV Details",
                    "icon": "team",
                    "path": "/servicerequest/playBonusCSV/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__playBonusCSV__details' */'/opt/build/repo/src/pages/servicerequest/playBonusCSV/details'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "create-PlayBonusCSV",
                    "icon": "team",
                    "path": "/servicerequest/create-playBonusCSV",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__playBonusCSV__create' */'/opt/build/repo/src/pages/servicerequest/playBonusCSV/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "SMS Provider",
                    "icon": "team",
                    "path": "/servicerequest/smsProvider",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__smsProvider' */'/opt/build/repo/src/pages/servicerequest/smsProvider'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Project Providers",
                    "icon": "team",
                    "path": "/servicerequest/smsProvider/project/:projectName",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__servicerequest__smsProvider__ProjectProviders' */'/opt/build/repo/src/pages/servicerequest/smsProvider/ProjectProviders'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/s3BucketList",
                "name": "S3-bucket-list",
                "icon": "SerReq",
                "authority": [
                  "admin",
                  "servicerequest-admin"
                ],
                "access": "isAccessible",
                "routes": [
                  {
                    "name": "Daily Report",
                    "icon": "team",
                    "path": "/s3BucketList/dailyReport",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__s3BucketList__dailyReport' */'/opt/build/repo/src/pages/s3BucketList/dailyReport'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/f3",
                "authority": [
                  "f3-admin",
                  "admin"
                ],
                "name": "f3",
                "icon": "video-camera",
                "access": "isAccessible",
                "routes": [
                  {
                    "name": "hosts",
                    "icon": "team",
                    "path": "/f3/hosts",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__f3__hosts' */'/opt/build/repo/src/pages/f3/hosts'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "rooms",
                    "icon": "shop",
                    "path": "/f3/rooms",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__f3__rooms' */'/opt/build/repo/src/pages/f3/rooms'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "games",
                    "icon": "fire",
                    "path": "/f3/games",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__f3__games' */'/opt/build/repo/src/pages/f3/games'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/rummy",
                "authority": [
                  "rummy-admin",
                  "rgs-admin",
                  "admin"
                ],
                "name": "rummy",
                "icon": "html5",
                "access": "isAccessible",
                "hideInMenu": true,
                "routes": [
                  {
                    "name": "tables",
                    "icon": "shop",
                    "path": "/rummy/tables",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rummy__tables' */'/opt/build/repo/src/pages/rummy/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create Table",
                    "icon": "shop",
                    "path": "/rummy/tables/create-table",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rummy__tables__create' */'/opt/build/repo/src/pages/rummy/tables/create'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "games",
                    "icon": "fire",
                    "path": "/rummy/games",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rummy__games' */'/opt/build/repo/src/pages/rummy/games'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/games",
                "authority": [
                  "games-admin",
                  "rgs-admin",
                  "admin"
                ],
                "access": "isAccessible",
                "name": "games",
                "icon": "crown",
                "routes": [
                  {
                    "name": "tables",
                    "icon": "shop",
                    "path": "/games/tables",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__games__tables' */'/opt/build/repo/src/pages/games/tables'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "path": "/callbreak",
                "authority": [
                  "callbreak-admin",
                  "rgs-admin",
                  "admin"
                ],
                "access": "isAccessible",
                "icon": "crown",
                "hideInMenu": true,
                "routes": [
                  {
                    "name": "tables",
                    "icon": "shop",
                    "path": "/callbreak/tables",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__callbreak__tables' */'/opt/build/repo/src/pages/callbreak/tables'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "games",
                    "icon": "fire",
                    "path": "/callbreak/games",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__callbreak__games' */'/opt/build/repo/src/pages/callbreak/games'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "create Table",
                    "icon": "shop",
                    "path": "/callbreak/tables/create-table",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__callbreak__tables__create' */'/opt/build/repo/src/pages/callbreak/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/snakesladders",
                "authority": [
                  "snl-admin",
                  "rgs-admin",
                  "admin"
                ],
                "access": "isAccessible",
                "name": "snl",
                "icon": "crown",
                "hideInMenu": true,
                "routes": [
                  {
                    "name": "tables",
                    "icon": "shop",
                    "path": "/snl/tables",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__snl__tables' */'/opt/build/repo/src/pages/snl/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create-table",
                    "icon": "shop",
                    "path": "/snakesladders/tables/create-table",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__snl__tables__create' */'/opt/build/repo/src/pages/snl/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/fantasy",
                "authority": [
                  "fantasy-admin",
                  "admin"
                ],
                "name": "fantasy",
                "icon": "crown",
                "access": "isAccessible",
                "routes": [
                  {
                    "name": "contest templates",
                    "icon": "smile",
                    "path": "/fantasy/contest-templates",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fantasy__contestTemplates' */'/opt/build/repo/src/pages/fantasy/contestTemplates'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create contest tempate",
                    "icon": "smile",
                    "path": "/fantasy/contest/create-template",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fantasy__contestTemplates__create' */'/opt/build/repo/src/pages/fantasy/contestTemplates/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "edit contest tempate",
                    "icon": "smile",
                    "path": "/fantasy/contest/edit-template/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fantasy__contestTemplates__create' */'/opt/build/repo/src/pages/fantasy/contestTemplates/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "matches",
                    "icon": "smile",
                    "path": "/fantasy/matches",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fantasy__matches' */'/opt/build/repo/src/pages/fantasy/matches'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "contests",
                    "icon": "smile",
                    "path": "/fantasy/contests",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fantasy__contests' */'/opt/build/repo/src/pages/fantasy/contests'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create contest",
                    "icon": "smile",
                    "path": "/fantasy/contest/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fantasy__contests__create' */'/opt/build/repo/src/pages/fantasy/contests/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "edit contest",
                    "icon": "smile",
                    "path": "/fantasy/contest/edit/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__fantasy__contests__create' */'/opt/build/repo/src/pages/fantasy/contests/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/ludo",
                "authority": [
                  "ludo-admin",
                  "rgs-admin",
                  "admin"
                ],
                "name": "ludo",
                "icon": "crown",
                "hideInMenu": true,
                "routes": [
                  {
                    "name": "tables",
                    "icon": "shop",
                    "path": "/ludo/tables",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ludo__tables' */'/opt/build/repo/src/pages/ludo/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create table",
                    "icon": "shop",
                    "path": "/ludo/tables/create-table",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ludo__tables__create' */'/opt/build/repo/src/pages/ludo/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/bingo",
                "authority": [
                  "bingo-admin",
                  "rgs-admin",
                  "admin"
                ],
                "name": "bingo",
                "icon": "crown",
                "hideInMenu": true,
                "routes": [
                  {
                    "name": "tables",
                    "icon": "shop",
                    "path": "/bingo/tables",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bingo__tables' */'/opt/build/repo/src/pages/bingo/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create table",
                    "icon": "shop",
                    "path": "/bingo/tables/create-table",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bingo__tables__create' */'/opt/build/repo/src/pages/bingo/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/promotions",
                "authority": [
                  "marketing",
                  "admin"
                ],
                "name": "promotions",
                "icon": "crown",
                "access": "isAccessible",
                "routes": [
                  {
                    "name": "coupons",
                    "path": "/promotions/coupon",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__coupon' */'/opt/build/repo/src/pages/promotions/coupon'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create coupon",
                    "path": "/promotions/coupon/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__coupon__create' */'/opt/build/repo/src/pages/promotions/coupon/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "banners",
                    "path": "/promotions/banner",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__banner' */'/opt/build/repo/src/pages/promotions/banner'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create banner",
                    "path": "/promotions/banner/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__banner__create' */'/opt/build/repo/src/pages/promotions/banner/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "user segment",
                    "path": "/promotions/userSegment",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__userSegment__tables' */'/opt/build/repo/src/pages/promotions/userSegment/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create segment",
                    "path": "/promotions/userSegment/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__userSegment__tables__create' */'/opt/build/repo/src/pages/promotions/userSegment/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Redeem Code",
                    "path": "/promotions/redeemCode",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__redeemCode' */'/opt/build/repo/src/pages/promotions/redeemCode'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Create Redeem Code",
                    "path": "/promotions/redeemCode/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__redeemCode__create' */'/opt/build/repo/src/pages/promotions/redeemCode/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Scratch Cards",
                    "path": "/promotions/scratchCard",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__scratchCard' */'/opt/build/repo/src/pages/promotions/scratchCard'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Create Scratch Card",
                    "path": "/promotions/scratchCard/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__scratchCard__create' */'/opt/build/repo/src/pages/promotions/scratchCard/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "path": "/promotions/FreeBets",
                    "authority": [
                      "marketing",
                      "admin"
                    ],
                    "name": "FreeBets",
                    "icon": "crown",
                    "access": "isAccessible",
                    "routes": [
                      {
                        "name": "Freebets",
                        "path": "/promotions/FreeBets/freeBets",
                        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__FBets__freeBets' */'/opt/build/repo/src/pages/promotions/FBets/freeBets'), loading: LoadingComponent}),
                        "exact": true
                      },
                      {
                        "name": "Assign FreeBet",
                        "path": "/promotions/FreeBets/freeBets/create",
                        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__FBets__freeBets__create' */'/opt/build/repo/src/pages/promotions/FBets/freeBets/create'), loading: LoadingComponent}),
                        "hideInMenu": true,
                        "exact": true
                      },
                      {
                        "name": "Freebet Instance",
                        "path": "/promotions/FreeBets/FreebetInstance",
                        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__FBets__FreebetInstance' */'/opt/build/repo/src/pages/promotions/FBets/FreebetInstance'), loading: LoadingComponent}),
                        "exact": true
                      },
                      {
                        "name": "Upload Freebet Instance CSV",
                        "path": "/promotions/FreeBets/FreebetInstance/create",
                        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__FBets__FreebetInstance__create' */'/opt/build/repo/src/pages/promotions/FBets/FreebetInstance/create'), loading: LoadingComponent}),
                        "hideInMenu": true,
                        "exact": true
                      },
                      {
                        "name": "Create Campaign",
                        "path": "/promotions/FreeBets/freeBets/createcampaign",
                        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__FBets__freeBets__createcampaign' */'/opt/build/repo/src/pages/promotions/FBets/freeBets/createcampaign'), loading: LoadingComponent}),
                        "hideInMenu": true,
                        "exact": true
                      },
                      {
                        "name": "Create Template Odds88",
                        "path": "/promotions/FreeBets/freeBets/create-template",
                        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__FBets__freeBets__createTemplateOdds88' */'/opt/build/repo/src/pages/promotions/FBets/freeBets/createTemplateOdds88'), loading: LoadingComponent}),
                        "hideInMenu": true,
                        "exact": true
                      }
                    ]
                  },
                  {
                    "name": "Comboboost",
                    "path": "/promotions/comboboost",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__CBoost__comboBoost' */'/opt/build/repo/src/pages/promotions/CBoost/comboBoost'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Assign Comboboost",
                    "path": "/promotions/comboboost/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__CBoost__comboBoost__create' */'/opt/build/repo/src/pages/promotions/CBoost/comboBoost/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Comboboost Instance",
                    "path": "/promotions/comboboostInstance",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__CBoost__comboBoostInstance' */'/opt/build/repo/src/pages/promotions/CBoost/comboBoostInstance'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Play Bonus",
                    "path": "/promotions/playBonus",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__playBonus' */'/opt/build/repo/src/pages/promotions/playBonus'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Create Play Bonus",
                    "path": "/promotions/playBonus/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__playBonus__create' */'/opt/build/repo/src/pages/promotions/playBonus/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Play Bonus Grants",
                    "path": "/promotions/playBonus/grants",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__playBonus__grants' */'/opt/build/repo/src/pages/promotions/playBonus/grants'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Play Bonus Grant Detail",
                    "path": "/promotions/playBonus/grants/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotions__playBonus__grants__detail' */'/opt/build/repo/src/pages/promotions/playBonus/grants/detail'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/cms",
                "name": "cms",
                "routes": [
                  {
                    "name": "Pages",
                    "path": "/cms/skin/:id/pages",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__pages__tables' */'/opt/build/repo/src/pages/cms/pages/tables'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "skins",
                    "path": "/cms/skins",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__skins__tables' */'/opt/build/repo/src/pages/cms/skins/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Category",
                    "path": "/cms/category",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__lobbies__tables' */'/opt/build/repo/src/pages/cms/lobbies/tables'), loading: LoadingComponent}),
                    "hideInMenu": false,
                    "exact": true
                  },
                  {
                    "name": "games",
                    "path": "/cms/games",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__gamesList__tables' */'/opt/build/repo/src/pages/cms/gamesList/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "ranking",
                    "path": "/cms/ranking",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__ranking__tables' */'/opt/build/repo/src/pages/cms/ranking/tables'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Category",
                    "path": "/cms/pages/:id/category",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__goToCategory__tables' */'/opt/build/repo/src/pages/cms/goToCategory/tables'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Event Ticker",
                    "path": "/cms/pages/:id/eventTicker",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__goToEventTicker__tables' */'/opt/build/repo/src/pages/cms/goToEventTicker/tables'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Create category",
                    "path": "/cms/category/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__lobbies__tables__create' */'/opt/build/repo/src/pages/cms/lobbies/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Create category",
                    "path": "/cms/category/create/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__lobbies__tables__create' */'/opt/build/repo/src/pages/cms/lobbies/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Event Ticker",
                    "path": "/cms/eventTicker",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__eventTicker' */'/opt/build/repo/src/pages/cms/eventTicker'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Create",
                    "path": "/cms/eventTicker/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__eventTicker__create' */'/opt/build/repo/src/pages/cms/eventTicker/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Edit",
                    "path": "/cms/eventTicker/edit",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__cms__eventTicker__create' */'/opt/build/repo/src/pages/cms/eventTicker/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/gms",
                "name": "gms",
                "routes": [
                  {
                    "name": "cashback-games",
                    "path": "/gms/cashback",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gms__cashback' */'/opt/build/repo/src/pages/gms/cashback'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "category-management",
                    "path": "/gms/category",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gms__category' */'/opt/build/repo/src/pages/gms/category'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Leaderboard",
                    "path": "/gms/leaderboard",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gms__leaderboard' */'/opt/build/repo/src/pages/gms/leaderboard'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Create Leaderboard",
                    "path": "/gms/leaderboard/create",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gms__leaderboard__create' */'/opt/build/repo/src/pages/gms/leaderboard/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Leaderboard Scoreboard",
                    "path": "/gms/leaderboard/:id/scoreboard",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gms__leaderboard__scoreboard' */'/opt/build/repo/src/pages/gms/leaderboard/scoreboard'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Leaderboard Prizes",
                    "path": "/gms/leaderboard/:id/prizes",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gms__leaderboard__prizes' */'/opt/build/repo/src/pages/gms/leaderboard/prizes'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  },
                  {
                    "name": "Leaderboard Categories",
                    "path": "/gms/leaderboard/:id/category",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gms__leaderboard__category' */'/opt/build/repo/src/pages/gms/leaderboard/category'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/gamezop",
                "name": "gamezop",
                "routes": [
                  {
                    "name": "tables",
                    "path": "/gamezop/tables",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gamezop__tables' */'/opt/build/repo/src/pages/gamezop/tables'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "create-tables",
                    "path": "/gamezop/table/create-table",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gamezop__tables__create' */'/opt/build/repo/src/pages/gamezop/tables/create'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/loyalty-levels",
                "name": "loyalty-levels",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LoyaltyLevels__tables' */'/opt/build/repo/src/pages/LoyaltyLevels/tables'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/loyalty-levels/LoyaltyLevels/create/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__LoyaltyLevels__create' */'/opt/build/repo/src/pages/LoyaltyLevels/create'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "path": "/gameReports",
                "name": "gameReports",
                "routes": [
                  {
                    "name": "Aviator",
                    "path": "/gameReports/aviator",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gameReports__Aviator' */'/opt/build/repo/src/pages/gameReports/Aviator'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Evolution",
                    "path": "/gameReports/evolution",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gameReports__Evolution' */'/opt/build/repo/src/pages/gameReports/Evolution'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "7mojos",
                    "path": "/gameReports/7mojos",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__gameReports__7mojos' */'/opt/build/repo/src/pages/gameReports/7mojos'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MetabaseChart' */'/opt/build/repo/src/pages/MetabaseChart'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/opt/build/repo/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/opt/build/repo/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
